/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TrendButtonDeleteMutationVariables = {|
  id: string
|};
export type TrendButtonDeleteMutationResponse = {|
  +recipeUpdate: ?{|
    +recipe: ?{|
      +id: string,
      +isTrend: boolean,
    |}
  |}
|};
export type TrendButtonDeleteMutation = {|
  variables: TrendButtonDeleteMutationVariables,
  response: TrendButtonDeleteMutationResponse,
|};
*/


/*
mutation TrendButtonDeleteMutation(
  $id: ID!
) {
  recipeUpdate(input: {id: $id, isTrend: false}) {
    recipe {
      id
      isTrend
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "isTrend",
            "value": false
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTrend",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrendButtonDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrendButtonDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TrendButtonDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TrendButtonDeleteMutation(\n  $id: ID!\n) {\n  recipeUpdate(input: {id: $id, isTrend: false}) {\n    recipe {\n      id\n      isTrend\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5654adbd058fb02fde499f674fd2795';

module.exports = node;
